import { render, staticRenderFns } from "./upLeft.vue?vue&type=template&id=fc4a62fc&scoped=true&"
import script from "./upLeft.vue?vue&type=script&lang=js&"
export * from "./upLeft.vue?vue&type=script&lang=js&"
import style0 from "./upLeft.vue?vue&type=style&index=0&id=fc4a62fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4a62fc",
  null
  
)

export default component.exports